const initialState = []

export const properties = (state = initialState, { type }) => {
  switch (type) {
    default:
      return state
  }
}
